var $144b40583c9847c5$exports = {};
$144b40583c9847c5$exports = {
    "Clear search": `\u{645}\u{633}\u{62D} \u{627}\u{644}\u{628}\u{62D}\u{62B}`
};


export {$144b40583c9847c5$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
